export default {"src":"/_next/static/media/card-check.28180ba4.svg","height":24,"width":24};